import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./index.module.scss";
import cn from "classnames";
import OrdersSectionItemInfoColumn from "../section-item/components/OrdersSectionItemInfoColumn";
import ToggleSwitchYes from "../../shared/icons/ToggleSwitchYes";
import ToggleSwitchNo from "../../shared/icons/ToggleSwitchNo";
import CustomInput from "../../custom/custom-input/CustomInput";
import OrdersDocumentCard from "../../orders/orders-documents/OrdersDocumentCard";
import CloseIconNew from "../../shared/icons/CloseIconNew";
import DocumentIcon from "../../shared/icons/DocumentIcon";
import InfoIcon from "../../shared/icons/InfoIcon";
import ArrowDownIconNew from "../../shared/icons/ArrowDownIconNew";
import { useSelector } from "react-redux";
import InsuranceExclusionsModal from "./InsuranceExclusionsModal";
import InsurancePhoneModal from "./InsurancePhoneModal";

const CargoInsurance = ({
  defaultValue = false,
  onClick,
  declaredPrice,
  setDeclaredPrice,
  fileInvoice,
  setInvoiceFile,
  detect,
  errorInsurance = "",
  errorFileInvoice = "",
  header,
  renderHeader,
  isReadOnly = false,
}) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user);
  const [isExclusionsOpen, setIsExclusionsOpen] = useState(false);
  const [isPhoneOpen, setIsPhoneOpen] = useState(false);

  // TO-DO: функционал страховки открыт только для тест
  const INSURANCE_TEST_COMPANY_IDS = [
    "686becf5e5695daae65de088",
    "69d894b7612386ae6f558c17",
    "6927df4d607351239585627f",
  ];
  const isInsuranceEnabled = user?.type === "Client" && INSURANCE_TEST_COMPANY_IDS.includes(user?.companyId);

  const changeInsurance = (value) => {
    if (isReadOnly || value === defaultValue) return;
    if (value && !user?.phoneNumber?.trim()) {
      setIsPhoneOpen(true);
      return;
    }
    onClick(value);
  };
  const getFile = (event) => {
    if (!isReadOnly) setInvoiceFile(event);
  };

  useEffect(() => {
    if (!defaultValue) {
      setIsExclusionsOpen(false);
    }
  }, [defaultValue]);

  return (
    <div className={cn(style.wrapper)}>
      {isInsuranceEnabled &&
        (renderHeader ? renderHeader({ onChange: changeInsurance, disabled: isReadOnly }) : header ?? (
          <div className={style.checkbox_wrapper}>
            <div className={style.checkbox_content}>
              <p>{t("cargoInsurance.enableInsurance")}</p>
              <span>{t("cargoInsurance.insuranceCostInfo3")}</span>
            </div>
            <button
              type="button"
              role="switch"
              aria-checked={defaultValue}
              aria-label={t("cargoInsurance.enableInsurance")}
              disabled={isReadOnly}
              className={cn(style.switch)}
              onClick={() => changeInsurance(!defaultValue)}
            >
              {defaultValue ? <ToggleSwitchYes /> : <ToggleSwitchNo />}
            </button>
          </div>
        ))}

      {defaultValue && (
        <>
          <div className={style.invoice_wrapper}>
            <OrdersSectionItemInfoColumn title={t("cargoInsurance.declaredValueTitle")} style={{ flex: 1 }}>
              <div>
                <CustomInput
                  inputType={"number"}
                  labelText={t("cargoInsurance.cargoValueLabel")}
                  placeholder={t("cargoInsurance.cargoValuePlaceholder")}
                  isBgGray
                  isDisabled={isReadOnly}
                  prefixEnd="₸"
                  value={declaredPrice === 0 ? "" : declaredPrice}
                  errorText={errorInsurance}
                  onChangeValue={(item) => {
                    if (!isReadOnly) setDeclaredPrice(item);
                  }}
                />
              </div>
            </OrdersSectionItemInfoColumn>

            {!fileInvoice?.name && !isReadOnly && (
              <OrdersSectionItemInfoColumn title={`${t("cargoInsurance.invoiceTitle")}*`}>
                <div className={style.btnUpload}>
                  <OrdersDocumentCard
                    key={"fileInvoice-add"}
                    isAddButton
                    text={t("cargoInsurance.uploadInvoiceButton")}
                    onUploadFile={getFile}
                    errorText={errorFileInvoice}
                  />
                </div>
              </OrdersSectionItemInfoColumn>
            )}

            {fileInvoice?.name && (
              <div className={cn(style.documentCard, style.cardItem)}>
                <DocumentIcon className={style.documentCard_icon} />
                <span className={style.documentCard_text}>{fileInvoice?.name}</span>
                {!isReadOnly && <button type="button" className={style.documentCard_close}
                  aria-label={t("cargoInsurance.removeInvoice")} onClick={() => setInvoiceFile(null)}>
                  <CloseIconNew
                    width={16}
                    height={16}
                    fill={"#909195"}
                  />
                </button>}
              </div>
            )}
          </div>

          <div className={style.insuranceNotice}>
            <InfoIcon className={style.insuranceNotice_icon} width={24} height={24} />
            <p className={style.insuranceNotice_text}>{t("cargoInsurance.availabilityNotice")}</p>
            <button
              type="button"
              className={style.insuranceNotice_action}
              onClick={() => setIsExclusionsOpen(true)}
              aria-expanded={isExclusionsOpen}
            >
              {t("cargoInsurance.viewExclusions")}
              <ArrowDownIconNew className={style.insuranceNotice_arrow} />
            </button>
          </div>
        </>
      )}

      <InsuranceExclusionsModal
        isOpen={isExclusionsOpen}
        onClose={() => setIsExclusionsOpen(false)}
      />
      {isPhoneOpen && !isReadOnly && (
        <InsurancePhoneModal onClose={() => setIsPhoneOpen(false)} onSaved={() => {
          setIsPhoneOpen(false);
          if (!defaultValue) onClick(true);
        }} />
      )}
    </div>
  );
};

export default CargoInsurance;
